"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinnerExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/spinner/examples/index.ts';
var SpinnerExample = /** @class */ (function () {
    function SpinnerExample() {
        this.active = true;
        this.hasMessage = false;
    }
    SpinnerExample.prototype.view = function () {
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), center: false, src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.Spinner, {
                active: this.active,
                background: this.background,
                fill: this.fill,
                intent: this.intent,
                size: this.size,
                message: this.hasMessage ? 'Uploading files...' : undefined
            })
        ]);
    };
    SpinnerExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)('h5', 'Size'),
            (0, mithril_1.default)(examples_1.SizeSelect, { onSelect: function (size) { return _this.size = size; } }),
            (0, mithril_1.default)('h5', 'Intent'),
            (0, mithril_1.default)(examples_1.IntentSelect, { onSelect: function (intent) { return _this.intent = intent; } }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.active,
                label: 'Active',
                onchange: function () { return _this.active = !_this.active; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.fill,
                label: 'Fill container',
                onchange: function () { return _this.fill = !_this.fill; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.background,
                label: 'Has background',
                onchange: function () { return _this.background = !_this.background; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.hasMessage,
                label: 'Message',
                onchange: function () { return _this.hasMessage = !_this.hasMessage; }
            })
        ];
    };
    return SpinnerExample;
}());
exports.SpinnerExample = SpinnerExample;
